import React from 'react';

import { Modal, Button } from 'antd';
import { LeftOutlined } from '@ant-design/icons';

// eslint-disable-next-line react/prop-types
const IframeModalView = ({ title, src, visible, setVisible, showBack }) => {
  return (
    <div>
      <Modal
        visible={visible}
        width={400}
        height={700}
        destroyOnClose
        contentStyle={{ padding: 0 }}
        bodyStyle={{ padding: 0 }}
        footer={null}
        onCancel={() => setVisible(false)}
      >
        <div>
          <div
            style={{
              width: '100%',
              height: 54,
              borderBottom: '1px solid #f0f0f0',
              alignContent: 'center',
            }}
          >
            {showBack && (
              <Button
                icon={<LeftOutlined />}
                type="text"
                size="large"
                onClick={() => {
                  window.history.go(-1);
                }}
              ></Button>
            )}
            <span
              style={{
                marginLeft: `${showBack ? 0 : '16px'}`,
                fontSize: 16,
                fontWeight: 500,
              }}
            >
              {title}
            </span>
          </div>
          <iframe
            width={400}
            height={670}
            scrolling="no"
            style={{
              width: '100%',
              border: 'none',
            }}
            src={src}
          />
        </div>
      </Modal>
    </div>
  );
};

export default IframeModalView;
